$(document).ready(function () {
  var slideCount = jQuery('.container-new .category_slide').length;
  if (slideCount <= 5) {
    // clone element
    jQuery('.container-new')
      .children()
      .clone(true, true)
      .appendTo('.container-new');
  }
  if (
    window.matchMedia('(min-width: 991px)').matches &&
    document.location.href.indexOf('collections') === -1
  ) {
    const isRTL = document.documentElement.dir === 'rtl';
    $('.category_sliders').not('.slick-initialized').slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: false,
      draggable: true,
      speed: 300,
      slidesToScroll: 1,
      slidesToShow: 4,
      swipeToSlide: true,
      rtl: isRTL
    });
  }
});
